// extracted by mini-css-extract-plugin
export default {"App":"Body_App__QDdKk","AppContainer":"Body_AppContainer__Gt7C0"};